import { NgModule } from "@angular/core";
import { PhonePipe } from "@app/pipes/phone-pipe";
import { FormatStatusPipe } from "@app/pipes/status-pipe";
import { InAppBrowserLinkPipe } from "@app/pipes/inAppBrowserLink.pipe";

@NgModule({
    imports: [],
    declarations: [ PhonePipe, InAppBrowserLinkPipe, FormatStatusPipe ],
    providers: [PhonePipe],
    exports: [ PhonePipe, InAppBrowserLinkPipe, FormatStatusPipe ]
})

export class PipesModule {}
